module.exports = __webpack_public_path__ + "img/start_story.9c9eab45.png";